import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash";

import { queryClient } from "App";
import { CALL_METRICS_TABLE_CONSTANTS } from "components/call_metrics_table/CallMetricsTableV3";
import { getCallMetricsTableColumns } from "components/call_metrics_table/CallMetricsColumnsAndFilters";
import { addResizedColumns } from "hooks/useTableConfig";
import UserService from "services/User";

export const invalidateCallMetricsTableQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [CALL_METRICS_TABLE_CONSTANTS.queryKey],
  });
};

export function useCallMetricsTable() {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getCallMetricsTableColumns();
    const callMetricsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${CALL_METRICS_TABLE_CONSTANTS.tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: callMetricsTableSettings?.resized_columns || {},
    });
    return withResizedColumns;
  }, [isTableSettingsFetched, tableSettings]);

  return {
    columns,
  };
}
